'use strict';

const CommentReactionAPI = require('communication/infra/api/comment-reaction');
const Snackbar = require('common/util/snackbar');

class CommentReactionRemoveService {
    constructor(project, comment, userKey, reactionName) {
        this._project = project;
        this._comment = comment;
        this._userKey = userKey;
        this._reactionName = reactionName;
    }

    execute() {
        const projectID = this._project.id;
        const commentID = this._comment.id;

        if (!this._comment.hasReaction(this._reactionName, this._userKey)) {
            // リアクションが付いていないので、何もしない
            return;
        }

        // ローカルには即時に反映しつつ、バックグラウンドでサーバ側に操作を同期させる
        this._comment.removeReaction(this._reactionName, this._userKey);

        CommentReactionAPI.delete(projectID, commentID, this._reactionName)
            .catch(() => {
                this._comment.addReaction(this._reactionName, this._userKey);
                Snackbar.error("リアクションの削除に失敗しました"); // TODO: 文言のi18n対応
            });
    }
}

module.exports = CommentReactionRemoveService;



// WEBPACK FOOTER //
// ./communication/app/service/comment/reaction/remove.js